document.addEventListener("DOMContentLoaded", () => {
    const backToTop = document.querySelector('.back-to-top');
    if (!backToTop) return;
    
    const topTarget = document.getElementById('backToTop');
    
    backToTop.addEventListener('click', (e) => {
        e.preventDefault();
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        
        window.scrollTo({
            top: 0,
            behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });

        setTimeout(() => {
            if (topTarget) {
                topTarget.focus({ preventScroll: true });
            }
        }, prefersReducedMotion ? 0 : 500);
    });
});
